import { useEffect, useState } from 'react';

export function useIsTabAndWindowActive(): boolean {
  const [isActive, setIsActive] = useState(() => {
    return !document.hidden && document.hasFocus();
  });

  useEffect(() => {
    const update = () => {
      const tabVisible = !document.hidden;
      const windowFocused = document.hasFocus();
      setIsActive(tabVisible && windowFocused);
    };

    document.addEventListener('visibilitychange', update);
    window.addEventListener('focus', update);
    window.addEventListener('blur', update);

    update();

    return () => {
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('focus', update);
      window.removeEventListener('blur', update);
    };
  }, []);

  return isActive;
}
